import type { InvestorSummary } from '@nemo/api';

export type RoleClass = NonNullable<InvestorSummary['roleClass']>;

/** How a role class reads in the people grid and its CSV. */
export function roleClassLabel(roleClass: RoleClass | null): string {
  switch (roleClass) {
    case null:
      return '';
    case 'investment':
      return 'Investment';
    case 'adjacent':
      return 'Adjacent';
    case 'support':
      return 'Support';
  }
}

/**
 * Where the fund panel puts a current role: the deal team (and anybody with
 * no title yet) in the list, advisers and venture partners behind a toggle,
 * support staff not at all.
 */
export function panelPlace(roleClass: RoleClass | null): 'shown' | 'adjacent' | 'hidden' {
  switch (roleClass) {
    case null:
    case 'investment':
      return 'shown';
    case 'adjacent':
      return 'adjacent';
    case 'support':
      return 'hidden';
  }
}
